














































import Vue from 'vue';
import { BButton } from 'bootstrap-vue';

import EditCardDropdown, { Option } from '@/components/cards/EditCard/components/EditCardDropdown.vue';
import { mapActions, mapGetters } from '@/state/modules/survey_builder';
import { QuestionCondition, Question } from '@/state/modules/survey_builder/state';

export default Vue.extend({
  name: 'QuestionEditCondition',
  components: {
    BButton,
    EditCardDropdown,
  },
  props: {
    condition: {
      type: Object as () => QuestionCondition,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      conditionQuestions: 'editQuestionConditionQuestions',
      isConditionQuestionValid: 'isEditQuestionConditionQuestionValid',
      isConditionOptionValid: 'isEditQuestionConditionOptionValid',
    }),

    isQuestionValid(): boolean {
      return this.isConditionQuestionValid(this.condition);
    },
    isOptionValid(): boolean {
      return this.isConditionOptionValid(this.condition);
    },

    questionValue(): string | undefined {
      return this.condition.shownByQuestionId != null ? `${this.condition.shownByQuestionId}` : undefined;
    },

    optionValue(): string | undefined {
      return this.condition.shownByOptionId != null ? `${this.condition.shownByOptionId}` : undefined;
    },

    conditionQuestionOptions(): Option[] {
      return this.conditionQuestions.map(question => ({
        value: `${question.id}`,
        label: `Page ${question.pageNumber} - Q${question.number}` + ` - ${question.title}`,
      }));
    },
    conditionQuestion(): Question | undefined {
      return this.conditionQuestions.find(question => question.id === this.condition.shownByQuestionId);
    },
    conditionOptionOptions(): Option[] {
      if (!this.conditionQuestion) {
        return [];
      }
      return this.conditionQuestion.options.map(option => ({
        value: `${option.id}`,
        label: option.title,
      }));
    },
  },
  methods: {
    ...mapActions({
      setConditionQuestion: 'setQuestionConditionQuestion',
      setConditionOption: 'setQuestionConditionOption',
      removeCondition: 'removeQuestionCondition',
    }),

    setQuestion(questionId: string) {
      this.setConditionQuestion({
        conditionId: this.condition.id,
        questionId: parseInt(questionId, 10),
      });
    },
    setOption(optionId: string) {
      this.setConditionOption({
        conditionId: this.condition.id,
        optionId: parseInt(optionId, 10),
      });
    },
    remove() {
      this.removeCondition(this.condition.id);
    },
  },
});
